import { useEffect } from "react";
import { Loader2 } from './icons';
import { useNavigate } from "react-router";
import { useAuth } from "../context/AuthContext";
const RESTORE_CEILING_MS = 800;
export function SessionRestoreScreen() {
  const { isRestoring, signOut } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!isRestoring) return;
    const timer = setTimeout(() => { signOut(); navigate("/login", { replace: true }); }, RESTORE_CEILING_MS);
    return () => clearTimeout(timer);
  }, [isRestoring, signOut, navigate]);
  if (!isRestoring) return null;
  return (<div style={{ position: "fixed", inset: 0, backgroundColor: "var(--color-background)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}><Loader2 size={32} color="var(--color-primary)" style={{ animation: "spin 1s linear infinite" }} /></div>);
}